import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

export default function NotFoundPage() {
  return (
    <div className="nf-page">
      <div className="nf-container">
        <span className="nf-kicker">404</span>
        <h1 className="nf-title">Page not found</h1>
        <p className="nf-sub">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="nf-actions">
          <Link to="/" className="nf-btn nf-btn--primary">Back to homepage</Link>
          <Link to="/listings" className="nf-btn nf-btn--outline">Browse listings</Link>
        </div>
        <p className="nf-hint">
          If you think this is a bug,{' '}
          <Link to="/contact" className="nf-hint__link">let us know</Link>.
        </p>
      </div>
    </div>
  );
}
